/* eslint-disable react/prop-types */
import React, { Fragment } from "react";
// Image and icon imports
import navIcon from "../../assets/images/nav-icon.png";
import growthBullet from "../../assets/images/growthBullet.svg";
// utilities and libraries
import { Menu } from "antd"; // Popular React UI library providing pre-built components like Menu

/**
 * Transforms the input data structure into a format compatible with antd Menu component
 * Input structure: { category: { subcategory: [items] } }
 * Output structure: Array of nested objects with keys, labels, and children
 * @param {Object} input - The original data structure
 * @returns {Array} Transformed data structure for Menu rendering
 */
function transformStructure(input) {
  let output = [];
  for (const category in input) {
    let categoryObj = {
      key: category,
      icon: null,
      children: [],
      label: category,
    };
    for (const subcategory in input[category]) {
      let subcategoryObj = {
        key: `${category}_${subcategory}`,
        icon: null,
        children: [],
        label: subcategory,
      };
      input[category][subcategory].forEach((item) => {
        let itemObj = {
          key: item.id,
          level: item.level,
          source: item.source,
          subsection_id: item.subsection_id,
          label: item.variable_name,
          icon: <img src={growthBullet} alt="" />,
        };
        subcategoryObj.children.push(itemObj);
      });
      categoryObj.children.push(subcategoryObj);
    }
    output.push(categoryObj);
  }
  return output;
}

/**
 * Finds and returns a specific object in the nested data structure using an array of keys
 * Used to locate the selected menu item in the original data structure
 * @param {Object} input - The original data structure
 * @param {Array} keysArray - Array of keys to traverse the structure
 * @returns {Object|null} The found object or null
 */
function findTargetObject(input, keysArray) {
  let targetObject = null;
  
  // First level: Get category object using first key
  const categoryKey = keysArray[0];
  targetObject = input[categoryKey];
  
  // Second level: Get subcategory array using the subcategory name
  if (keysArray[1]) {
    const subcategoryName = keysArray[1].split('_')[1];
    targetObject = targetObject[subcategoryName];
  }
  
  // Third level: Find specific item by ID in the array
  if (keysArray[2]) {
    targetObject = targetObject.find(item => item.id === Number(keysArray[2]));
  }
  
  return targetObject;
}

function LeftNavigation({
  sectionList,
  selectedSection,
  handleSelectSections,
}) {
  /**
   * Handles menu item click events
   * Uses keyPath from event to find and return the selected item
  */
  const onClick = (e) => {
    const a = findTargetObject(sectionList, e.keyPath.reverse());
    handleSelectSections(a);
  };

  // Transform the data structure for Menu component
  const items = transformStructure(sectionList);
  
  return (
    <Fragment>
      {sectionList && (
        <div className="leftNavigationContainer">
          <div className="nav-container nav-indicators">
            <h2 className="secondary-heading">INDICATORS</h2>
            <Menu
              onClick={onClick}
              mode="vertical"
              style={{
                overflow: "auto",
              }}
              items={items}
            />
          </div>
          <div className="nav-container nav-dashboard">
            <h2 className="secondary-heading">MORE DASHBOARDS</h2>
            <a className="nav-links" href={process.env.REACT_APP_ECOMETER_LINK}>
              <p>Ecometer</p>
              <img src={navIcon} alt="" className="nav-icon" />
            </a>
            <a
              className="nav-links"
              href={process.env.REACT_APP_AGRI_MARKET_LINK}
            >
              <p>Agri-Market</p>
              <img src={navIcon} alt="" className="nav-icon" />
            </a>
            <a
              className="nav-links"
              href={process.env.REACT_APP_DAILY_FOOD_PRICES_LINK}
            >
              <p>Daily Food Prices</p>
              <img src={navIcon} alt="" className="nav-icon" />
            </a>
          </div>
        </div>
      )}
    </Fragment>
  );
}

// Memoize component to prevent unnecessary re-renders
export default React.memo(LeftNavigation);
